angular.module('shared').directive('logItemBody', function() {
  return {
    restrict: 'E',
    scope: {
      log: '=',
      displayGym: '=',
      variant: '@'
    },
    template: require('templates/shared/log_item_body.html.slim'),
    controller: ["$scope", function($scope) {
      $scope.isCreateGroup = function() {
        return $scope.log.filter_group === 'create_group';
      };
      $scope.isCommunicationGroup = function() {
        return $scope.log.filter_group === 'communication_group';
      };
      $scope.toggleChanges = function() {
        return $scope.changesOpened = !$scope.changesOpened;
      };
      $scope.hasDetails = function() {
        return $scope.hasCreateValues() || $scope.hasUpdateValues() || $scope.hasNestedUpdateValues() || $scope.isCommunicationGroup();
      };
      $scope.hasCreateValues = function() {
        return !_.isEmpty($scope.log.fragments.create_values);
      };
      $scope.hasUpdateValues = function() {
        var ref;
        return !_.isEmpty((ref = $scope.log.fragments.update_values) != null ? ref.changes : void 0);
      };
      $scope.hasNestedUpdateValues = function() {
        var ref, ref1;
        return (ref = $scope.log.fragments.update_values) != null ? (ref1 = ref.nested_changes) != null ? ref1.length : void 0 : void 0;
      };
      return $scope.changesOpened = $scope.hasDetails() && $scope.isCreateGroup();
    }]
  };
});
